module.exports = __webpack_public_path__ + "static/img/icon-new-zh-left.09b72c65.svg";